module.exports = __webpack_public_path__ + "static/media/IPCCC.70e50736.jpg";